/**
 * Button label helper.
 *
 * The button holds its label three times over: one copy in each of the two
 * colour layers, plus a visually-hidden one for the accessible name. Any
 * script that used to do `button.textContent = 'Added'` would collapse all
 * three into a bare word and take the reveal with them. This writes into every
 * copy instead, and falls back to textContent for plain buttons — so a caller
 * does not have to know which kind of button it has.
 *
 * The .cb__i selector is kept for safety, not because anything emits it any
 * more: the seven marquee copies it referred to went with the marquee.
 */
(function () {
  "use strict";
  window.Calmy = window.Calmy || {};

  window.Calmy.setButtonLabel = function (el, text) {
    if (!el) return;
    var copies = el.querySelectorAll(".cb__i, .cb__label");
    if (!copies.length) { el.textContent = text; return; }
    copies.forEach(function (c) { c.textContent = text; });
    var sr = el.querySelector(".calmy-sr");
    if (sr) sr.textContent = text;
  };
})();
